export default __webpack_public_path__ + "static/media/furniture6.9b13f654.jpeg";